export const cartSupportedTlds = new Set(['com', 'net', 'org']);
export const DOMAIN_IN_CART_SPEC = 'specs.premium.DomainInCart';
//# sourceMappingURL=eligibility.js.map